
export default () => ({
    status: 'authenticating', // 'authenticated','not-authenticated', 'authenticating'
    user: null,
    resp: null,
    api_token: null
    // idToken: null,
    // refreshToken: null
})